import { ReactNode } from 'react';
import { css } from '@emotion/css';

import { THEME_COLOR } from '@/archive/styles/colors';

const titleStyle = css`
    width: 100%;
    font-size: 20px;
    color: ${THEME_COLOR.GREY_05};
    line-height: 1.4;
    font-weight: bold;
    padding-top: 40px;
    > span {
        position: relative;
        left: 50%;
        margin-left: -660px;
        top: -10px;
    }
`;

interface Props {
    pageTitle: string;
    children: ReactNode;
    className?: string;
}

const DefaultPageLayout = ({ pageTitle, children, className }: Props) => {
    return (
        <>
            <h4 className={titleStyle}>
                <span>{pageTitle}</span>
            </h4>
            <article className={className}>{children}</article>
        </>
    );
};

export default DefaultPageLayout;
